export const getCommissionAgentScope = (userInfo) => {
    const user = userInfo?.data?.user || {};
    const agent = userInfo?.data?.agent || {};
    const isAgentUser = Number(user?.userTypeId) === 3;

    const agentId = agent?.agentId || user?.agentId || '';
    const agentCode = agent?.agentCode || user?.agentCode || '';
    const firstName = agent?.firstName || user?.firstName || '';
    const lastName = agent?.lastName || user?.lastName || '';

    return {
        isAgentUser,
        agentId,
        agentCode,
        firstName,
        lastName,
        initialAgent: agentId || agentCode
            ? {
                ...agent,
                agentId,
                agentCode: agentCode || agentId,
                firstName,
                lastName,
            }
            : null,
    };
};

const pickExactAgent = (result, scope) => {
    if (!Array.isArray(result) || result.length === 0) return null;

    return result.find((item) => scope?.agentCode && String(item?.agentCode) === String(scope.agentCode))
        || result.find((item) => scope?.agentId && String(item?.agentId) === String(scope.agentId))
        || result[0]
        || null;
};

export const findLoggedAgent = async ({ dispatch, callSearchAgentInfo, scope }) => {
    if (!scope?.isAgentUser) return null;
    if (!scope?.agentId && !scope?.agentCode) return null;

    // Agent users are resolved by their own agent code first, as shown in the UI.
    // If the login payload has no code (or the code lookup returns nothing), fall back
    // to the exact agentId so the page is still locked to the authenticated agent.
    if (scope?.agentCode) {
        const byCodeResponse = await dispatch(callSearchAgentInfo({
            keyword: scope.agentCode,
            page: 1,
            maxResult: 10,
            agentId: null,
        }));

        const byCodeResult = byCodeResponse?.payload?.responseCode === '00000'
            ? (byCodeResponse?.payload?.data?.result || [])
            : [];
        const byCodeAgent = pickExactAgent(byCodeResult, scope);

        if (byCodeAgent) {
            return {
                ...scope.initialAgent,
                ...byCodeAgent,
                agentId: byCodeAgent?.agentId || scope.agentId,
                agentCode: byCodeAgent?.agentId || scope.agentId || scope.agentId,
            };
        }
    }

    if (scope?.agentId) {
        const byIdResponse = await dispatch(callSearchAgentInfo({
            keyword: null,
            page: 1,
            maxResult: 1,
            agentId: scope.agentId,
        }));

        const byIdResult = byIdResponse?.payload?.responseCode === '00000'
            ? (byIdResponse?.payload?.data?.result || [])
            : [];
        const byIdAgent = pickExactAgent(byIdResult, scope);

        if (byIdAgent) {
            return {
                ...scope.initialAgent,
                ...byIdAgent,
                agentId: byIdAgent?.agentId || scope.agentId,
                agentCode: byIdAgent?.agentId || scope.agentId || scope.agentId,
            };
        }
    }

    return scope.initialAgent;
};
